import { PaginatorPassThroughMethodOptions } from 'primevue/paginator';

export default {
  root: {
    class: 'text-[13px] rounded-xl dark:bg-surface-900 !py-0 !px-0',
  },
  pcrowperpagedropdown: {
    class: 'focus:!ring-0 dark:focus:!ring-0',
  },
  previousPageButton: {
    class: '!min-w-[26px] h-8 m-[0.143rem]',
  },
  nextpagebutton: {
    class: '!min-w-[26px] !max-w-[26px] h-8 m-[0.143rem]',
  },
  lastPageButton: {
    class: '!min-w-[26px] h-8 m-[0.143rem]',
  },
  firstPageButton: {
    class: '!min-w-[26px] h-8 m-[0.143rem]',
  },
  rowPerPageDropdown: {
    root: {
      class: 'max-w-[78px]',
    },
  },
  paginatorContainer: {
    class: ['py-0'],
  },
  pages: {
    class: 'mr-2',
  },
  page: ({ context }: PaginatorPassThroughMethodOptions<any>) => ({
    class: [
      'focus:!ring-0 dark:focus:!ring-0',
      '!h-10 !min-w-10 dark:rounded-full',
      {
        '!bg-gray-50 dark:!bg-gray-800': context.active,
      },
    ],
  }),
  content: {
    class: 'app-paginator-content flex items-center',
  },
};
